import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";

export const fetchPermissions = createAsyncThunk(
  "permissions/fetchPermissions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/modulemaster/list/`);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch modules"
      );
    }
  }
);


export const fetchPermissionsById = createAsyncThunk(
  "permissions/fetchPermissionsById",
  async (userId: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `/permissions/permissions_list/${userId}/`
      );
      console.log("response: ", response);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch permissions"
      );
    }
  }
);

export const submitPermissions = createAsyncThunk(
  "permissions/submitPermissions",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await Axios.post(
        `/permissions/permissions_list/create/`,
        payload
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
